import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'base_role',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isBaseRole());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/BaseRolePerimeter.js